import { ModuleFE_PermissionDomain } from './ModuleFE_PermissionDomain.js';
export const ModulePackFE_PermissionDomain = [ModuleFE_PermissionDomain];
//# sourceMappingURL=module-pack.js.map